module.exports = __webpack_public_path__ + "media/images/ziprecruiter_and_careerplug-85010b063162ebc789fc61c6ada03510.png";